import {NgModule} from '@angular/core';
import {ApparatusCardCommonComponent} from './apparatus-card-common.component';
import {FormFieldModule} from '@components/form-field/form-field.module';
import {ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {LayoutModule} from '../../layout-components/layout.module';
import {DirectivesModule} from '@helpers/directives/directives.module';
import {FilesUploaderModule} from '@components/files-uploader/files-uploader.module';
import {IconsModule} from '@lab365/icons';

@NgModule({
    declarations: [ApparatusCardCommonComponent],
    exports: [ApparatusCardCommonComponent],
    imports: [
        FormFieldModule,
        ReactiveFormsModule,
        CommonModule,
        LayoutModule,
        DirectivesModule,
        FilesUploaderModule,
        IconsModule,
    ],
    providers: [
    ]
})
export class ApparatusCardCommonModule {}
